/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function($){
  // Cache the selectors for better performance
   var $accordionHeaders = $(".acc-heading");
   var $accordionContents = $(".acc-content");
 
   // Open the first section by default
   $accordionHeaders.first().addClass("active-accordians");
   $accordionContents.first().slideDown(200);
 
   // Accordion toggle functionality
   $accordionHeaders.on("click", function() {
     var $this = $(this);  // The clicked header
     var $content = $this.siblings(".acc-content");  // The corresponding content
 
     // If the clicked header is already active, close it
     if ($this.hasClass("active-accordians")) {
       $this.removeClass("active-accordians");
       $content.slideUp(200);
     } else {
       // Close all content sections and remove active class from all headers
       $accordionHeaders.removeClass("active-accordians");
       $accordionContents.stop(true, true).slideUp(200);
 
       // Open the clicked section
       $this.addClass("active-accordians");
       $content.stop(true, true).slideDown(200);
     }
   });
  
  setTimeout(function () {
      $('div#delivery_text').html($('div.trustblox-1-timer-wrap').html());
      $('a.simpAskQuestion-btn, a.simpAskForm-cancel-btn').removeAttr('target');
  }, 5000);

  
 
});